export function createApplicant(details = {}) {
    return {
        ...{
            firstname: '',
            middlename: '',
            lastname: '',
            gender: '',
            birthdate: '',
            passport: null,
            birthcertificate: null,
            nationality: '',
            residency: '',
            address: '',
            is_spelling_confirmed: false,
        },
        ...details
    }
}